<template>
  <div>

    <el-table class="table" size="mini" :data="tableData" :height="hh" border>

      <el-table-column type="expand">
        <template slot-scope="scope">

          <div v-if="scope.row.listEScanRecordImg !=null ">
            <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.listEScanRecordImg" :key="index">
              <img :src="imgUrl+item.imgPath" style="width: 500px"/>
              <img slot="reference" :src="imgUrl+item.imgPath+'_64x64.jpg'" style="width:60px">
            </el-popover>
          </div>

        </template>
      </el-table-column>

      <el-table-column prop="elderlyName" width="100" label="姓名"></el-table-column>
      <el-table-column prop="name" width="100" label="文件名称"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column width="100" label="图片数量">
        <template slot-scope="scope">

         {{scope.row.listEScanRecordImg.length}}张

          <el-image
              style="width:10px;height: 10px;"
              :src="imgAdd"
              :preview-src-list="getImgPath(scope.row.listEScanRecordImg)">
          </el-image>

        </template>
      </el-table-column>
      <el-table-column prop="createTime" :formatter="timefilter" label="上传时间"  min-width="100"></el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="addImg(scope.$index, scope.row)">上传图片</el-button>
          <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
      <div style="float: left;">
        <el-pagination small
                       background
                       layout="prev, pager, next"
                       :total="totalItems"
                       :page-size="pageSize"
                       :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
      </div>
      <div style="float: right">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
      </div>
      <div style="clear: both;"></div>
    </div>

    <ScanRecordAdd ref="myScanRecordAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
                         v-on:resultSuccess="resultSuccess"></ScanRecordAdd>
    <ScanRecordAddImg ref="myScanRecordAddImg" v-show="showModalAddImg" v-on:closeMe="showModalAddImg=false"
                   v-on:resultSuccess="resultSuccess"></ScanRecordAddImg>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import ScanRecordAdd from "./ScanRecordAdd";
import ScanRecordAddImg from "./ScanRecordAddImg";

export default {
  name: "ExaminationRecords",
  data(){
    return{
      showModalAdd: false,
      showModalAddImg: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      userCode: "",
      elderlyCode: "",
      elderlyName:'',


      hh:this.$store.state.tableHeight-170,
      imgUrl: this.$imgUrl,
      imgAdd:require("@/assets/fullScreen.png"),

    }
  },
  created(){

  },
  components:{
    ScanRecordAdd,ScanRecordAddImg
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.hh = val - 170;
    },
    disabled(val){
      //this.th = this.$store.state.tableHeight-(val?50:100);
    }
  },
  methods:{
    init(userCode,elderlyCode,elderlyName) {

      this.elderlyCode=elderlyCode;
      this.userCode=userCode;
      this.elderlyName = elderlyName;
      this.getList();
    },

    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myScanRecordAdd.init(this.elderlyCode,this.userCode);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    addImg(index,row){
      this.showModalAddImg = !this.showModalAddImg;
      this.$refs.myScanRecordAddImg.init(row.escanRecordCode);
    },

    getImgPath(arr){
      let arr2 = [];
      for(let i=0;i<arr.length;i++){
        arr2.push(this.imgUrl+arr[i].imgPath);
      }
      return arr2;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    resultSuccess(){
      this.currentPage = 1;
      this.getList();
    },

    getList() {
      this.$axios({
        method: "post",
        url: this.$shopUrl + "EScanRecord/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode: this.elderlyCode,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        },
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue).substring(0,11)
    },

    handleDelete(index,row){

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "EScanRecord/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            escanRecordCode:row.escanRecordCode,

          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.getList();

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)

    },




  },

}
</script>

<style scoped>

</style>
